import React, { createContext, useEffect, useState } from "react";

const CampContext = createContext();

const CampProvider = ({ children }) => {
    const initialState = {
        currentCamp: {
            fechaLanzamiento: "",
            fechaVencimiento: "",
            habilitada: false,
            hash: null,
            nombre: "",
            nroCliente: null,
            id: null
        },
        action: "",
        search:true,
        form: true,
        param: false,
    };

    const [state, setState] = useState(initialState);

    const handleState = (newState)=>{
        setState(newState)
    }

    const resetState = ()=>{
        setState({...initialState})
    }
    // useEffect(() => {
    //     console.log("🚀 state", state)
    // }, [state]);

    return (
        <CampContext.Provider
            value={{
                state,
                setState:handleState,
                resetState
            }}
        >
            {children}
        </CampContext.Provider>
    );
};

export { CampProvider, CampContext };



// WEBPACK FOOTER //
// ./src/context/CampContext.js